export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';
export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const SAVE_FILTERS = 'SAVE_FILTERS';
export const CHANGE_PAGE_NO = 'CHANGE_PAGE_NO';
export const CHANGE_LIMIT = 'CHANGE_LIMIT';
